import React, { useState } from "react";
import { Box, IconButton, Paper, Typography, Button, Grid } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";

/* ---------------- HELP DATA ---------------- */

const helpTopics = [
  {
    title: "Registration",
    questions: [
      { q: "How do I update profile?", a: "Dashboard → Profile → Edit Profile." },
      { q: "Can I change email?", a: "Yes, from Profile Settings." }
    ]
  },
  {
    title: "Upgrade Wallet",
    questions: [
      { q: "How do i upgrade my wallet", a: "Profile → Security → Reset TPIN." },

    ]
  },
  {
    title: "KYC",
    questions: [
      { q: "How long does KYC take?", a: "Usually 5–10 minutes." },
      { q: "What if KYC fails?", a: "Re-upload documents." }
    ]
  },
  {
    title: "Bank",
    questions: [
      { q: "Add bank account?", a: "Bank → Add Account." },
      { q: "Change bank later?", a: "Yes anytime." }
    ]
  },
  {
    title: "Wallet Limits",
    questions: [
      { q: "Increase limit?", a: "Wallet → Limits." },
      { q: "Daily cap?", a: "Yes." }
    ]
  },
  {
    title: "Transactions",
    questions: [
      { q: "View history?", a: "Dashboard → Transactions." },
      { q: "Export data?", a: "Yes available." }
    ]
  },
  {
    title: "Refunds",
    questions: [
      { q: "Refund time?", a: "3–5 working days." },
      { q: "Refund status?", a: "Transaction History → Refunds." }
    ]
  },
  {
    title: "Support",
    questions: [
      { q: "Contact support?", a: "support@tawallet.com" },
      { q: "Chat available?", a: "Yes inside app." }
    ]
  },
];

/* ---------------- COMPONENT ---------------- */

export default function HelpChat() {
  const [open, setOpen] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  return (
    <>
      {/* Floating Chat Button */}
      {!open && (
        <Box sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 1500 }}>
          <IconButton
            onClick={() => setOpen(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              bgcolor: "primary.main",  

              color: "#fff",
              boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
              transition: "0.3s",
              "&:hover": {
                bgcolor: "primary.main",
                transform: "scale(1.1)",
                boxShadow: "0 15px 30px rgba(0,0,0,0.4)"
              }
            }}>
            <ChatIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      )}
      {open && (
        <Paper
          elevation={6}
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            width: 360,
            height: 480,
            display: "flex",
            flexDirection: "column",
            borderRadius: 2
          }}
        >
          {/* Header */}
          <Box sx={{ bgcolor: "primary.main", color: "#fff", p: 1.5, display: "flex", justifyContent: "space-between" }}>
            <Typography>Help Center</Typography>
            <IconButton onClick={() => { setOpen(false); setSelectedTopic(null); setSelectedQuestion(null); }} sx={{ color: "#fff" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Body */}
          <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>

            {/* TOPIC GRID */}
            {!selectedTopic && (
              <Grid container spacing={1}>
                {helpTopics.map((topic, i) => (
                  <Grid item xs={6} key={i}>
                    <Box
                      onClick={() => setSelectedTopic(topic)}
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        border: "1px solid #ddd",
                        textAlign: "center",
                        cursor: "pointer",
                        "&:hover": { bgcolor: "#f5f5f5" }
                      }}
                    >
                      <Typography fontSize={13} fontWeight="bold">
                        {topic.title}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}

            {/* QUESTIONS */}
            {selectedTopic && !selectedQuestion && (
              <>
                <Typography fontWeight="bold" mb={1}>{selectedTopic.title} FAQs</Typography>
                {selectedTopic.questions.map((item, i) => (
                  <Box
                    key={i}
                    onClick={() => setSelectedQuestion(item)}
                    sx={{
                      p: 1.5,
                      mb: 1,
                      borderRadius: 2,
                      border: "1px solid #ddd",
                      cursor: "pointer",
                      "&:hover": { bgcolor: "#f5f5f5" }
                    }}
                  >
                    {item.q}
                  </Box>
                ))}
                <Button size="small" onClick={() => setSelectedTopic(null)}>← Back</Button>
              </>
            )}

            {/* ANSWER */}
            {selectedQuestion && (
              <>
                <Typography fontWeight="bold">Answer</Typography>
                <Typography mb={2}>{selectedQuestion.a}</Typography>
                <Button size="small" onClick={() => setSelectedQuestion(null)}>← Back to Questions</Button>
              </>
            )}

          </Box>
        </Paper>
      )}
    </>
  );
}
